<div data-testid="unsaved-changes-dialog">
  <h2 mat-dialog-title>
    {{ 'UNSAVED_CHANGES' | translate }}

    <button
      [mat-dialog-close]="false"
      data-testid="unsaved-changes-dialog-close-btn"
      aria-label="close"
      mat-icon-button
      matSuffix
    >
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <div mat-dialog-content>
    <rs-font-light>{{ 'UNSAVED_CHANGES_INFO_DIALOG' | translate }}</rs-font-light>
  </div>

  <div mat-dialog-actions>
    <button
      [mat-dialog-close]="true"
      data-testid="exit-without-saving-btn"
      class="rs-btn--text"
      mat-button
    >
      {{ 'EXIT_WITHOUT_SAVING' | translate }}
    </button>

    <button
      [mat-dialog-close]="false"
      data-testid="unsaved-changes-back-btn"
      class="rs-btn--primary"
      mat-button
    >
      {{ 'BACK' | translate }}
    </button>
  </div>
</div>